// alert.service.ts
import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { BehaviorSubject, Observable } from 'rxjs';
import { GET_ALERT_DASHBOARD_DATA } from '../../../../../store/entities/warehouse-management/alert-dashboard/alert-dashboard.graphql';


export interface Alert {
  warehouseName: string;
  createdAt: string;
  status: string;
  alertType: string;
  reading: string;
}



@Injectable({
  providedIn: 'root'
})
export class AlertService {
  private alertDataSubject = new BehaviorSubject<Alert[]>([]);
  public alertData$ = this.alertDataSubject.asObservable();

  constructor(private apollo: Apollo) {}

  fetchAlertData(): void {
    this.apollo
      .query({
        query: GET_ALERT_DASHBOARD_DATA,
        variables: { filtering: { pageNumber: 1 } },
      })
      .subscribe(
        (result: any) => {
          const extractedData = result?.data?.getSensorAlertData?.data || [];
          const transformedData = extractedData.map((alert: any) => {
            let alertTypeDescription: string;

            if (alert.alertType === 'MAX_TEMPERATURE') {
              alertTypeDescription = 'Maximum Temperature';
            } else if (alert.alertType === 'MAX_HUMIDITY') {
              alertTypeDescription = 'Maximum Humidity';
            } else if (alert.alertType === 'MIN_HUMIDITY') {
              alertTypeDescription = 'Minimum Humidity';
            } else if (alert.alertType === 'MIN_TEMPERATURE') {
              alertTypeDescription = 'Minimum Temperature';
            } else {
              alertTypeDescription = alert.alertType || 'N/A';
            }

            return {
              warehouseName: alert.warehouseName,
              reading: alert.reading || 'N/A',
              alertType: alertTypeDescription,
              createdAt: new Date(alert.createdAt).toLocaleString(),
              status: alert.status || 'N/A'
            };
          });

          this.alertDataSubject.next(transformedData);
        },
        (error) => {
          console.error('Error fetching alerts:', error);
          this.alertDataSubject.next([]);
        }
      );
  }

  getAlertData(): Observable<Alert[]> {
    return this.alertData$;
  }
}